import { Button, Divider, Image } from 'antd'
import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'

export const Main = styled.div`
  margin: 15px 0;
`
export const MainHeading = styled.h1`
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : '30px')};
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 1.5em;
  color: ${COLORS.GREY_T_10};
`
export const NameAdd1 = styled(Flex)`
  gap: 3px;
`
export const NameAdd = styled(Flex)`
  gap: 3px;
  padding-left: 15px;
`
export const TextLight1 = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  display: flex;
  align-items: center;
  color: #676e83;
`

export const VerticalDivider = styled(Divider)`
  height: 50px;
`

export const BoldTextDate = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  align-items: center;
  color: #343e59;
`

export const SecondaryHeading = styled.h2`
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : '10px')};
  font-style: normal;
  font-weight: ${props => (props.fontWeight ? props.fontWeight : '700')};
  font-size: ${props => (props.fontSize ? props.fontSize : '16px')};
  line-height: 1.5em;
  color: ${COLORS.GREY_T_10};
  span {
    text-transform: uppercase;
  }
`
export const SecondaryHeadingNew = styled.h2`
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : '10px')};
  font-style: normal;
  font-weight: ${props => (props.fontWeight ? props.fontWeight : '700')};
  font-size: ${props => (props.fontSize ? props.fontSize : '16px')};
  line-height: 1.5em;
  color: ${COLORS.GREY_T_10};
`
export const SkillHeading = styled.h2`
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : '10px')};
  font-style: normal;
  font-weight: ${props => (props.fontWeight ? props.fontWeight : '700')};
  font-size: 14px;
  line-height: 1.5em;
  color: ${COLORS.GREY_T_10};
  span {
    text-transform: uppercase;
  }
`

export const SecondaryHeadingNew1 = styled.h2`
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : '10px')};
  font-style: normal;
  padding: 0px;
  font-weight: ${props => (props.fontWeight ? props.fontWeight : '700')};
  font-size: 16px;
  line-height: 21px;
  text-transform: capitalize;
  color: ${COLORS.GREY_T_10};
`

export const StyledP = styled.p`
  height: auto;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.75em;
  color: ${COLORS.GREY_T_40};
  ${props => props.webkitBox && `display: -webkit-box`};
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  text-overflow: ellipsis;
  overflow-wrap: break-word;
`
export const StyledDivider = styled(Divider)`
  margin: ${props => (props.margin ? props.margin : '24px 0')};
`
export const SubFLex = styled(Flex)`
  ${props => props.gap && `gap: ${props.gap};`}
  ${props => props.marginBottom && ` margin-bottom: ${props.marginBottom};`};
  ${props => props.paddingLeft && ` padding-left: ${props.paddingLeft};`};
`
export const GreyText = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 12.5px;
  line-height: 0.938em;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_40)};
  span {
    margin-right: 10px;
  }
`

export const GreyTextNew = styled.p`
  text-transform: capitalize;
  font-style: normal;
  font-weight: 500;
  font-size: 12.5px;
  line-height: 0.938em;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_40)};
  span {
    margin-right: 10px;
  }
`
export const EditorContent = styled.span`
  padding: 20px 0;
  * {
    line-height: 188%;
    color: #808697 !important;
  }
  p,
  ul,
  ol {
    margin-bottom: 10px;
  }

  li {
    line-height: 25px;
  }
`

export const ExtraSpace = styled.div`
  padding-left: 58px;
`
export const ExtraSpaceNew = styled.div`
  padding-top: 10px;
`

export const RewardTite = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 18px;
  color: #1b1f22;
  padding-bottom: 10px;
  padding-top: 20px;
`
export const Marks = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 21px;
  text-align: right;
  color: ${COLORS.GREY_T_10};
  span {
    color: ${COLORS.GREY_T_60};
  }
`
export const SecondGreyText = styled.p`
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : '8px')};
  font-style: normal;
  font-weight: 600;
  font-size: 1em;
  line-height: 1.125em;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_40)};
`
export const OtherFlex = styled(Flex)`
  width: 25%;
  margin-right: 30px;
`
export const DocumentFlex = styled(Flex)`
  ${props => props.gap && `gap: ${props.gap};`}
  width: 50%;
`
export const ImagePreview = styled(Image)`
  .ant-image-preview-mask {
    position: fixed;
    top: 41% !important;
    right: 0;
    bottom: 0;
    left: 41% !important;
    height: 37%;
    width: 37%;
    background-color: rgba(0, 0, 0, 0.45);
  }
`
export const PopoverImg = styled.embed`
  border-radius: 4.45455px;
  width: 264px;
  height: 196px;
`
export const PreButton = styled(Button)`
  border: none;
  background: ${COLORS.WHITE};
  &:hover {
    background-color: ${COLORS.WHITE};
    border-color: ${COLORS.PURPLE_T_80};
  }
  &:focus {
    background-color: ${COLORS.WHITE};
    border-color: ${COLORS.PURPLE_T_80};
  }
`

export const RewardTiteNew = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  color: #1b1f22;
  padding-bottom: 10px;
`
export const RewardTiteOther = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  color: #1b1f22;
  padding-bottom: 10px;
  padding-left: 60px;
`
